import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import axios from "axios";
import { handleAxiosError } from "./servicesUtils";
//@ts-ignore
import { appendQueryString } from "@utils/UrlBuilderUtils";
//@ts-ignore
var baseURL = window["_baseURLIt"];
var baseController = "/ws";
export var getPlacesByQuery = function getPlacesByQuery(value) {
  var placeType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var provinceId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
  return __awaiter(void 0, void 0, void 0, function* () {
    try {
      if (!provinceId) provinceId = "";
      var res = yield axios.get("".concat(baseController, "/places?query=").concat(value, "&type=").concat(placeType.join(",")).concat(provinceId ? "&provinceID=".concat(provinceId) : ""));
      return res.data;
    } catch (err) {
      handleAxiosError(err);
      throw err;
    }
  });
};
export function getPlace(query) {
  var types = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "C,P,Z,L,I,R,A";
  return new Promise(resolve => {
    axios.get("".concat(baseController, "/places?query=").concat(query, "&type=").concat(types)).then(response => {
      if (!(response === null || response === void 0 ? void 0 : response.data)) {
        resolve([]);
      }
      resolve(response === null || response === void 0 ? void 0 : response.data);
    });
  });
}
export function getZones(cityID) {
  return new Promise(resolve => {
    axios.get("".concat(baseController, "/zones?cityID=").concat(cityID)).then(response => {
      if (!(response === null || response === void 0 ? void 0 : response.data)) {
        resolve([]);
        return;
      }
      resolve(response === null || response === void 0 ? void 0 : response.data);
    });
  });
}
export var getDistrictsByZoneId = zoneID => __awaiter(void 0, void 0, void 0, function* () {
  try {
    var res = yield axios.get(appendQueryString(new URL("".concat(baseURL).concat(baseController, "/districts")), {
      zoneID
    }).toString());
    return res.data;
  } catch (e) {
    handleAxiosError(e);
    throw e;
  }
});